import type { VueRoute } from "ui-kit/RouterVue";
import { h } from "vue";

const routes: VueRoute[] = [
  {
    path: "/chats/:id/contacts",
    action: async ({ pathname }) => {
      const c = await import("@/modules/contacts/views/contactsLinked.vue");
      return h(c.default, { id: pathname.groups.id, type: "chat" });
    },
  },
  {
    path: "/chats/:slug?",
    action: async ({ pathname }) => {
      const id = pathname.groups.slug;
      const c = id
        ? await import("./views/chatEdit.vue")
        : await import("./views/chats.vue");
      return h(c.default, { id });
    },
  },
];

export default routes;
